import { IonSpinner } from "@ionic/react";

export function SpinnerView() {
  return (
    <div
      style={{
        height: "100%",
        flexGrow: 1,
        flexShrink: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <IonSpinner name="lines" />
    </div>
  );
}
